// @flow

import { completeRequest, beginRequest } from "@store/utils";
import type { AbsenceReasonsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetAbsenceReasonsList = (state: AbsenceReasonsState) => () => ({
  ...state,
  isLoading: true,
});

export const onAddNewAbsenceReason = (state: AbsenceReasonsState) => () => startRequest(state);
export const onAddNewAbsenceReasonSuccess = (state: AbsenceReasonsState) => () =>
  finishRequest(state);
export const onAddNewAbsenceReasonError = (state: AbsenceReasonsState) => () =>
  finishRequest(state);

export const onExportLiveAbsenceReasons = (state: AbsenceReasonsState) => () => startRequest(state);
export const onExportLiveAbsenceReasonsSuccess = (state: AbsenceReasonsState) => () =>
  finishRequest(state);
export const onExportLiveAbsenceReasonsError = (state: AbsenceReasonsState) => () =>
  finishRequest(state);

export const onUpdateAbsenceReason = (state: AbsenceReasonsState) => () => startRequest(state);
export const onUpdateAbsenceReasonSuccess = (state: AbsenceReasonsState) => () =>
  finishRequest(state);
export const onUpdateAbsenceReasonError = (state: AbsenceReasonsState) => () =>
  finishRequest(state);

export const onGetAbsenceReasonsListSuccess = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  isLoading: false,
  error: null,
  list: payload,
});

export const onGetAbsenceReasonsListError = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  isLoading: false,
  success: false,
  error: payload,
});

export const onNewAbsenceReason = (state: AbsenceReasonsState) => () => ({
  ...state,
  draft: {
    name: null,
    displayName: null,
    reasonType: null,
    nurseTransferEligibility: null,
    parentReason: null,
  },
});

export const onShowAddAbsenceReasonModal = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddAbsenceReasonModal: payload,
  },
});

export const onUpdateAbsenceReasonDraft = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  draft: payload,
});

export const onGetAbsenceReasonSchemaSuccess = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  schema: payload,
});

export const onGetAbsenceReasonSchemaError = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  schema: null,
  error: payload,
});

export const onGetAbsenceReasonActiveSuccess = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetAbsenceReason = (state: AbsenceReasonsState) => () => startRequest(state);

export const onGetAbsenceReasonSuccess = (state: AbsenceReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetAbsenceReasonError = (state: AbsenceReasonsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onResetAbsenceReason = (state: AbsenceReasonsState) => () => ({
  ...state,
  current: null,
});

export const onShowAbsenceReasonEditModal = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onChangeAbsenceReasonsFilterState = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  filterState: payload,
});

export const onChangeAbsenceReasonsFilterType = (state: AbsenceReasonsState) => ({
  payload,
}: Object) => ({
  ...state,
  filterType: payload,
});
